import { DatePicker, Table, TableColumn, Select, Option } from 'element-ui';
import { EventBus } from '@/services/Event.js';
import ResourceSvc from '@/services/resource.svc.js';
const svc = new ResourceSvc();

export default {
    name: 'AdminTransactionTab',
    components: { [Table.name]: Table, [TableColumn.name]: TableColumn},
    data() {
        return {
            isLoading: false,
            paymentItemId: 0,
            transaction: {
                transactionCode: '',
                paymentDate: '',
                totalRefunded: 0,
                totalRefunds: 0,
                totalPayments: 0,
                totalPaymentAmount: 0,
                paymentItems: [{
                    paymentAsArray:[],
                    payment: {
                        tiPaymentId: 0,
                        descriptionArray: [],
                        description: '',
                        purchaseTypeString: '',
                        priceDetails: { priceBeforeDiscount: 0, priceAfterDiscount: 0, discount: 0 },
                        itemName: '',
                        itemTypeString: '',
                        price: 0
                    },
                    refunds: [{
                        refundTransactionCode: '',
                        paymentTransactionCode: '',
                        createdByUserIdString: '',
                        refundDateString: '',
                        refundReason: '',
                        refundAmount: 0,
                    }],
                    totalRefunded: 0
                }]
            }
        }
    },
    methods: {
        loadData(paymentId) {
            var self = this;
            if (self.isLoading || paymentId == 0) return;
            self.paymentItemId = paymentId;
            self.isLoading = true;
            svc.getFullTransaction({ paymentId: self.paymentItemId }).then(function (resp) {
                var allData = resp.body;
                if (!allData || !allData.isSuccess) {
                    self.$notify({ message: 'Payments records not found, something went wrong, please contact with dev team. ' + allData.message, type: 'danger' });
                    return;
                }
                self.transaction = allData;
                self.transaction.paymentItems.forEach(item => {
                    item.paymentAsArray = [];
                    item.payment.totalRefunded = item.totalRefunded;
                    item.payment.refundsCount = item.refunds.length;
                    item.paymentAsArray.push(item.payment);
                });
                self.isLoading = false;
            }, function (resp) {
                self.$notify({ message: 'Something went wrong, please contact with dev team: ' + resp.body, timeout: 60000, type: 'danger' });
                self.isLoading = false;
            });
        },
        backToPreviousTab() {
            EventBus.$emit("admin_hide_transaction");
        },
        setInitialParams() {
            var self = this;
            EventBus.$on("admin_load_transaction", paymentId => {
                if (paymentId == 0) return;
                self.loadData(paymentId);
            });
        }
    },
    created() {
        this.setInitialParams();
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/payments/transaction-tab/transaction-tab.js